export default __webpack_public_path__ + "static/media/icn_list_guide_1.dde2c4ea.svg";